import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { KeyRound } from 'lucide-react';

const BACKEND_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:8000'
  : (process.env.REACT_APP_BACKEND_URL || '');

const TrocarSenha = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFirstLogin = location.state?.firstLogin === true;

  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.newPassword !== form.confirm) {
      setError('As senhas não coincidem.');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('student_token');
      await axios.patch(`${BACKEND_URL}/api/students/password`, {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Atualiza flag no localStorage
      const user = JSON.parse(localStorage.getItem('student_user') || '{}');
      localStorage.setItem('student_user', JSON.stringify({ ...user, mustChangePassword: false }));

      navigate('/area');
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao trocar a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 pt-20 lg:pt-0">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <KeyRound size={32} className="mx-auto mb-4 text-white opacity-50" />
          <h1 className="text-2xl font-bold tracking-tight uppercase mb-2">
            {isFirstLogin ? 'Crie sua senha' : 'Trocar senha'}
          </h1>
          {isFirstLogin && (
            <p className="text-[#A3A3A3] text-sm">
              Por segurança, crie uma senha pessoal antes de continuar.
            </p>
          )}
        </div>

        <div className="bg-[#121212] border border-white/10 p-8">
          {error && (
            <div className="mb-6 p-4 bg-red-900/20 border border-red-500/30 text-red-400 text-sm">{error}</div>
          )}
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="block text-xs text-[#A3A3A3] uppercase tracking-widest mb-2">
                {isFirstLogin ? 'Senha temporária' : 'Senha atual'}
              </label>
              <input
                type="password" required value={form.currentPassword}
                onChange={e => setForm({ ...form, currentPassword: e.target.value })}
                className="w-full px-4 py-3 bg-[#0A0A0A] border border-white/10 focus:border-white/40 outline-none text-sm transition-colors"
              />
            </div>
            <div>
              <label className="block text-xs text-[#A3A3A3] uppercase tracking-widest mb-2">Nova senha</label>
              <input
                type="password" required value={form.newPassword}
                onChange={e => setForm({ ...form, newPassword: e.target.value })}
                className="w-full px-4 py-3 bg-[#0A0A0A] border border-white/10 focus:border-white/40 outline-none text-sm transition-colors"
                placeholder="Mínimo 6 caracteres"
              />
            </div>
            <div>
              <label className="block text-xs text-[#A3A3A3] uppercase tracking-widest mb-2">Confirmar nova senha</label>
              <input
                type="password" required value={form.confirm}
                onChange={e => setForm({ ...form, confirm: e.target.value })}
                className="w-full px-4 py-3 bg-[#0A0A0A] border border-white/10 focus:border-white/40 outline-none text-sm transition-colors"
              />
            </div>
            <button
              type="submit" disabled={loading}
              className="w-full py-3 bg-white text-black font-bold uppercase tracking-widest text-sm hover:bg-[#E5E5E5] transition-colors mt-2 disabled:opacity-50"
            >
              {loading ? 'Salvando...' : 'Salvar senha'}
            </button>
            {!isFirstLogin && (
              <button type="button" onClick={() => navigate('/area')}
                className="text-[#A3A3A3] text-xs text-center hover:text-white transition-colors"
              >
                Cancelar
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default TrocarSenha;
